import { Grid } from "@material-ui/core";
import * as React from "react";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { ErrorModal } from "../../../components/modals/error-modal";
import { TableUsers } from "./components/UsersDataTable/TableUsers";
import { useUsersContext } from "./context/UsersContext";
import { getUsers } from "./repositories/UsersRepository";

type Props = {};

export const Users = (prop: Props) => {
	const {
		actions: { setUsers },
	} = useUsersContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getUsersFromAPI = async () => {
		setIsLoading(true);
		const resp = await getUsers();
		if (resp.ok) {
			setUsers(resp.data.tables[0].rows);
			setIsLoading(false);
		} else {
			setError(resp.message);
		}
	};

	useEffect(() => {
		getUsersFromAPI();
	}, []);

	return (
		<Grid container justifyContent="center" alignItems="center">
			<Grid item md={12} xs={12} style={{ margin: 0 }}>
				<div style={{ width: "100%", padding: "10px 0 20px" }}>
					<TableUsers isLoading={isLoading} getUsersFromAPI={getUsersFromAPI} />
				</div>
				<Outlet />
			</Grid>
			<ErrorModal error={error} onHide={() => setError("")} />
		</Grid>
	);
};
